import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { KYMW1507Model } from './kymw1507.model';
import { KYMW1507InputModel } from './vo/kymw1507-input.model';
import { RegistCwsIconFileDataVo } from './vo/regist-cws-icon-file-data.model';
import { GetMarkGroupListService } from '../kymw1500/api-services/get-mark-group-list.service';
import { GetCwsIconBaseData } from './api-services/get-cws-icon-base-data-service';
import { RegistCwsIconFileData } from './api-services/regist-cws-icon-file-data-service';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { FileUploadService, FileAccept } from '../../../commons/kymw02/file-upload/file-upload.service';

/**
 * 別アイコンファイル登録画面を管理するクラス
 *
 * @export KYMW1507Component
 * @class KYMW1507Component
 */
@Component({
  selector: 'app-kymw1507',
  templateUrl: 'kymw1507.component.html',
  styleUrls: ['kymw1507.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1507Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('txt_IconCode', { static: true }) txt_IconCode: ElementRef;
  @ViewChild('txt_StartOrderCode', { static: true }) txt_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txt_EndOrderCode', { static: true }) txt_EndOrderCode: OrderCodeTextInputComponent;

  kymw1507Model: KYMW1507Model = new KYMW1507Model();

  /**
   *Creates an instance of KYMW1507Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1507Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private getMarkGroupListService: GetMarkGroupListService,
    private getCwsIconBaseData: GetCwsIconBaseData,
    private registCwsIconFileData: RegistCwsIconFileData,
    private getCodeListService: GetCodeListService,
    private elementRef: ElementRef,
    private fileUploadService: FileUploadService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1507Component
   */
  public ngOnInit() {
    this.componentName = 'KYMW1507';

    // マークグループ一覧取得
    this.getMarkGroupListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        // マークグループコードが取得できませんでした
        this.dialogService.openAlertGetMessage('E0127', null, () => {
          this.closeFunction();
        });
      }
      this.kymw1507Model.updateMarkGroupList(data);

      // コード区分情報取得
      this.getCodeListService.execute(
        'ctp051',
        '',
        this.kymw1507Model,
        'arrangeDivList',
        () => {
          // アイコン区分情報取得
          this.getCodeListService.execute(
            'ctp050',
            '',
            this.kymw1507Model,
            'iconDivList',
            () => {
              // CWSアイコン基本情報取得
              this.getCwsIconBaseData.execute({
                iconCode: this.kymw1507Model.iconCode
              }, (data: any) => {
                if (data === null || data === undefined || Object.keys(data).length === 0) {
                  // アイコン情報は存在しません
                  this.dialogService.openAlertGetMessage('E0122', ['アイコン情報'], () => {
                    this.closeFunction();
                  });
                }
                this.kymw1507Model.updateCwsIconBaseData(data);
                setTimeout(() => {
                  // 使用終了受注コードにフォーカスがいくため遅延評価
                  this.txt_IconCode.nativeElement.focus();
                }, 100)
              });
            }
          )
        }
      )
    });
  }

  /**
   * 画面初期値設定
   *
   * @param vo
   * @memberof KYMW1507Component
   */
  public setInterfaceParam(vo: KYMW1507InputModel) {
    this.kymw1507Model.iconCode = vo.iconCode;
    this.kymw1507Model.iconCodeBranch = vo.iconCodeBranch;
  }

  /**
   * 指定なし（開始） チェックボックス 値変更
   *
   * @memberof KYMW1507Component
   */
  public eventNotDesignateStart_CLICKHandler() {
    if (this.kymw1507Model.notDesignateStart) {
      this.kymw1507Model.startOrderCode = '';
      this.kymw1507Model.startOrderCodeEnabled = false;
    } else {
      this.kymw1507Model.startOrderCodeEnabled = true;
    }
  }

  /**
   * 指定なし（終了） チェックボックス 値変更
   *
   * @memberof KYMW1507Component
   */
  public eventNotDesignateEnd_CLICKHandler() {
    if (this.kymw1507Model.notDesignateEnd) {
      this.kymw1507Model.endOrderCode = '';
      this.kymw1507Model.endOrderCodeEnabled = false;
    } else {
      this.kymw1507Model.endOrderCodeEnabled = true;
    }
  }

  /**
   * アイコンファイル(通常) 選択 ボタン 押下
   */
  public eventImageNormal_ClickHandler(): void {
    this.selectFile('Normal');
  }

  /**
   * アイコンファイル(大) 選択 ボタン 押下
   */
  public eventImageBig_ClickHandler(): void {
    this.selectFile('Big');
  }

  /**
   * アイコンファイル(モバイル) 選択 ボタン 押下
   */
  public eventImageMobile_ClickHandler(): void {
    this.selectFile('Mobile');
  }

  /**
   * アイコンファイル選択共通処理
   */
  private selectFile(imageType: string) {
    this.fileUploadService.upload((selectedFiles: File[]) => {
      const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);
      if (extension !== 'jpg') {
        this.dialogService.openAlertGetMessage('E0220');
        return;
      }
      if (imageType === 'Normal') {
        this.kymw1507Model.imageFileNormal = selectedFiles[0];
        this.kymw1507Model.imageFileNameNormal = selectedFiles[0].name;
        this.kymw1507Model.imageFileUrlNormal = window.URL.createObjectURL(selectedFiles[0]);
      } else if (imageType === 'Big') {
        this.kymw1507Model.imageFileBig = selectedFiles[0];
        this.kymw1507Model.imageFileNameBig = selectedFiles[0].name;
        this.kymw1507Model.imageFileUrlBig = window.URL.createObjectURL(selectedFiles[0]);
      } else if (imageType === 'Mobile') {
        this.kymw1507Model.imageFileMobile = selectedFiles[0];
        this.kymw1507Model.imageFileNameMobile = selectedFiles[0].name;
        this.kymw1507Model.imageFileUrlMobile = window.URL.createObjectURL(selectedFiles[0]);
      }
    }, [FileAccept.JPG], false);
  }

  /**
   * 追加 ボタン 押下
   *
   * @memberof KYMW1507Component
   */
  public eventAdd_CLICKHandler() {
    if (!this.kymw1507Model.notDesignateStart && this.kymw1507Model.startOrderCode === '') {
      this.dialogService.openAlertGetMessage('E0110', ['使用開始受注コード']);
      return;
    }
    if (!this.kymw1507Model.notDesignateEnd && this.kymw1507Model.endOrderCode === '') {
      this.dialogService.openAlertGetMessage('E0110', ['使用終了受注コード']);
      return;
    }
    if (!this.kymw1507Model.notDesignateStart && !this.txt_StartOrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0122', ['使用開始受注コード']);
      return;
    }
    if (!this.kymw1507Model.notDesignateEnd && !this.txt_EndOrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0122', ['使用終了受注コード']);
      return;
    }
    if (!this.kymw1507Model.notDesignateStart && !this.kymw1507Model.notDesignateEnd) {
      if (Number(this.kymw1507Model.startOrderCode) > Number(this.kymw1507Model.endOrderCode)) {
        this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
        return;
      }
    }
    if (this.kymw1507Model.imageFileNameNormal === '') {
      this.dialogService.openAlertGetMessage('E0103', ['アイコンファイル(通常)']);
      return;
    }
    if (this.kymw1507Model.imageFileNameBig === '') {
      this.dialogService.openAlertGetMessage('E0103', ['アイコンファイル(大)']);
      return;
    }
    if (this.kymw1507Model.imageFileNameMobile === '') {
      this.dialogService.openAlertGetMessage('E0103', ['アイコンファイル(モバイル)']);
      return;
    }

    // 入力した情報で%1を登録しますか？
    this.dialogService.openAlertGetMessage('Q0104', ['別アイコンファイル情報'], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        const fileList: File[] = [
          this.kymw1507Model.imageFileNormal,
          this.kymw1507Model.imageFileBig,
          this.kymw1507Model.imageFileMobile,
        ];

        this.registCwsIconFileData.execute(new RegistCwsIconFileDataVo(
          this.kymw1507Model.iconCode,
          this.kymw1507Model.startOrderCode,
          this.kymw1507Model.endOrderCode,
          this.kymw1507Model.iconAlternativeText
        ), fileList, () => {
          this.updateInitDisplay();
        });
      }
    });
  }

  /**
   * 初期表示状態に更新する
   *
   * @memberof KYMW1507Component
   */
  public updateInitDisplay() {
    this.kymw1507Model.startOrderCode = this.kymw1507Model.startOrderCodeInit;
    this.kymw1507Model.notDesignateStart = this.kymw1507Model.startOrderCode === '';
    this.kymw1507Model.startOrderCodeEnabled = !this.kymw1507Model.notDesignateStart;
    this.kymw1507Model.endOrderCode = this.kymw1507Model.endOrderCodeInit;
    this.kymw1507Model.notDesignateEnd = this.kymw1507Model.endOrderCode === '';
    this.kymw1507Model.endOrderCodeEnabled = !this.kymw1507Model.notDesignateEnd;
    this.kymw1507Model.imageFileNormal = null;
    this.kymw1507Model.imageFileNameNormal = '';
    this.kymw1507Model.imageFileUrlNormal = '';
    this.kymw1507Model.imageFileBig = null;
    this.kymw1507Model.imageFileNameBig = '';
    this.kymw1507Model.imageFileUrlBig = '';
    this.kymw1507Model.imageFileMobile = null;
    this.kymw1507Model.imageFileNameMobile = '';
    this.kymw1507Model.imageFileUrlMobile = '';
    this.kymw1507Model.iconAlternativeText = '';
  }
}
